import { InjectionToken } from '@angular/core';
import { Platform } from '@mnz-core/models/_enums';

/**
 *  Provides the platform ( production | acceptance | test | development | unit_test )
 */
export const MNZ_PLATFORM = new InjectionToken<Platform>('MNZ_PLATFORM');
